module.exports = __webpack_public_path__ + "img/WIDE_PORTA-UN-AMICO_1920x256-New.65b0f19b.jpg";